import React, { useCallback, useState } from 'react';
import styled from 'styled-components';

import { Icon } from '@stats/playbook-components';

import TableCel from './TableCel';

const StyledToggleCel = styled.td`
  padding: 8px;
`;

interface RowProps {
  odd: boolean;
}

const StyledRow = styled.tr<RowProps>`
  background-color: ${(props) => (props.odd ? '#f2f2f2' : '#fff')};
`;

const StyledSubRow = styled.tr<RowProps>`
  background-color: ${(props) => (props.odd ? '#f2f2f2' : '#fff')};

  td:first-child {
    background-color: #fff;
  }

  td {
    padding: 3px 6px;
    vertical-align: middle;
    span {
      margin-top: 2px;
      display: inline-block;
    }
  }
`;

type TableColumnProps = {
  key: string;
  label?: string;
  render?: Function;
};

type TableRowProps = {
  rowkey: string;
  columns: Array<TableColumnProps>;
  rowdata: any;
  subdata?: Function;
  subdataKey?: string;
  subdataRender?: Function;
  odd: boolean;
};

const TableRow: React.FC<TableRowProps> = (props) => {
  const { rowkey, columns, rowdata, subdata, subdataKey, odd, subdataRender } = props;
  const [subDataOpen, setSubDataOpen] = useState(false);
  const [subDataRows, setSubDataRows] = useState<Array<any>>([]);

  const handleClick = useCallback(async () => {
    if (subdata) {
      const rows = await subdata();
      setSubDataRows(rows);
      setSubDataOpen(!subDataOpen);
    }
  }, [subdata, subDataOpen])

  return (
    <>
      <StyledRow odd={odd}>
        {subdataRender && (
          <StyledToggleCel key="expand">
            {subdata && (
              <Icon
                size="small"
                variant={subDataOpen ? 'chevron-up' : 'chevron-down'}
                onClick={handleClick}
                role={subDataOpen ? 'up-icon' : 'down-icon'}
              />
            )}
          </StyledToggleCel>
        )}
        {columns.map((column) => (
          <TableCel
            key={rowkey + column.key}
            data={rowdata}
            render={column.render}
          />
        ))}
      </StyledRow>

      {subdata && subdataKey && subDataOpen && (
        <>
          {subDataRows.map((row, idx) => (
            <StyledSubRow odd={idx % 2 === (odd ? 1 : 0)} key={row[subdataKey]}>
              <TableCel data="&nbsp;" />
              <TableCel
                colspan={columns.length}
                data={row}
                render={subdataRender}
              />
            </StyledSubRow>
          ))}
        </>
      )}
    </>
  );
};

export default TableRow;
